import { render } from "./problems.vue?vue&type=template&id=1d46eac3"
import script from "./problems.vue?vue&type=script&lang=js"
export * from "./problems.vue?vue&type=script&lang=js"

import "./problems.vue?vue&type=style&index=0&id=1d46eac3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__